import {FormControl, ValidationErrors, Validator} from '@angular/forms';

/**
 * Validates whether numeric value is between minValue and maxValue.
 * Blank value is always correct.
 *
 */
export class MinMaxValueValidator implements Validator {

    private maxValue: number;
    private minValue: number;

    constructor(minValue: number, maxValue: number) {
        this.minValue = minValue;
        this.maxValue = maxValue;
    }

    public static validator(minValue: number, maxValue: number) {
        const validator = new MinMaxValueValidator(minValue, maxValue);
        return (control: FormControl): ValidationErrors | null => validator.validate(control);
    }

    validate(control: FormControl): ValidationErrors | null {

        let error = false;

        const _self = this;
        const value = control.value;

        if (typeof value !== 'undefined' && value != null && (value + '').length) {
            if ((value + '').match(/\d+/) !== null) {
                const num = Number(value);
                if ((this.minValue != null && num < this.minValue) || (this.maxValue != null && num > this.maxValue)) {
                    error = true;
                }
            } else {
                error = true;
            }
        }
        return error ? {
            'minmaxValue': {
                value: value,
                minValue: _self.minValue,
                maxValue: _self.maxValue
            }
        } : null;
    }
}
